import { render, staticRenderFns } from "./OrgMemberList.vue?vue&type=template&id=3b501915"
import script from "./OrgMemberList.vue?vue&type=script&lang=js"
export * from "./OrgMemberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports